import {
  defaultDatepickerOptions,
  initializeDatepicker,
} from '../../components/datepicker';

$(() => {
  const closeDisclaimer = $('#close-disclaimer');
  const dateInput = $("input[name='date_of_birth']").get(0);
  if (dateInput) {
    initializeDatepicker(dateInput, {
      ...defaultDatepickerOptions,
      ...dateInput.options,
    });
  }

  closeDisclaimer.on('click', () => {
    $('#account-disclaimer').slideUp();
  })
});
